import React from 'react';

import { useIntl } from 'react-intl';

import { queryClient } from 'src/lib/react-query';
import { DataTableNewEntryProps } from 'src/registry/components/table/types';
import { generalMessages } from 'src/registry/utils/messages';
import { ICON_MAP } from 'src/utils/constants';
import { useUpdateRole } from 'src/features/roles/api/useUpdateRole';
import { LIST_ROLES_RESOURCE } from 'src/features/roles/api/useListRoles';
import { toast } from 'src/hooks/useToast';
import { rolesMessages } from 'src/features/roles/utils/messages';
import RoleFormModal from 'src/features/roles/components/forms/RoleFormModal';
import { Role } from 'src/features/roles/utils/types';

interface RoleFormModalProps<TData> extends DataTableNewEntryProps<TData> {
    selectedRole: Role;
    children?: React.ReactNode;
}

function UpdateRoleFormModal<TData>({ className, semantics, children, selectedRole }: RoleFormModalProps<TData>) {
    const { formatMessage } = useIntl();

    const { mutate, isPending } = useUpdateRole({
        onSuccess: (success) => {
            void queryClient.invalidateQueries({ queryKey: [LIST_ROLES_RESOURCE] });
            toast({
                title: formatMessage(rolesMessages.updateRoleSuccess),
                description: formatMessage(rolesMessages.updateRoleSuccessDescription, {
                    entry: success.name,
                }),
            });
        },
    });

    return (
        <RoleFormModal
            selectedRole={selectedRole}
            className={className}
            mutate={(data, onSuccess, onError) => mutate({ data, roleId: selectedRole.id }, { onSuccess, onError })}
            title={formatMessage(generalMessages.editEntry, { entry: semantics?.entryName?.toLowerCase() })}
            icon={ICON_MAP.EDIT}
            isPending={isPending}
            subtitle={formatMessage(rolesMessages.editRoleSubtitle, {
                entry: selectedRole.name,
            })}
        >
            {children}
        </RoleFormModal>
    );
}

export default UpdateRoleFormModal;
